/**
 * Country utility functions
 * Maps countries to their default currencies, locales, and date formats.
 * Country is the primary field on Agency; currency is derived from country
 * but can be overridden.
 */

export const COUNTRIES = [
  { code: 'AU', name: 'Australia', flag: '🇦🇺', currency: 'AUD', locale: 'en-AU' },
  { code: 'PH', name: 'Philippines', flag: '🇵🇭', currency: 'PHP', locale: 'en-PH' },
  { code: 'US', name: 'United States', flag: '🇺🇸', currency: 'USD', locale: 'en-US' },
  { code: 'GB', name: 'United Kingdom', flag: '🇬🇧', currency: 'GBP', locale: 'en-GB' },
  { code: 'NZ', name: 'New Zealand', flag: '🇳🇿', currency: 'NZD', locale: 'en-NZ' },
  { code: 'CA', name: 'Canada', flag: '🇨🇦', currency: 'CAD', locale: 'en-CA' },
  { code: 'JP', name: 'Japan', flag: '🇯🇵', currency: 'JPY', locale: 'ja-JP' },
  { code: 'SG', name: 'Singapore', flag: '🇸🇬', currency: 'SGD', locale: 'en-SG' },
  { code: 'HK', name: 'Hong Kong', flag: '🇭🇰', currency: 'HKD', locale: 'en-HK' },
  { code: 'KR', name: 'South Korea', flag: '🇰🇷', currency: 'KRW', locale: 'ko-KR' },
  { code: 'DE', name: 'Germany', flag: '🇩🇪', currency: 'EUR', locale: 'de-DE' },
  { code: 'FR', name: 'France', flag: '🇫🇷', currency: 'EUR', locale: 'fr-FR' },
];

// Country code → default currency code
const COUNTRY_CURRENCY_MAP = {};
COUNTRIES.forEach(c => { COUNTRY_CURRENCY_MAP[c.code] = c.currency; });

/**
 * Get the default currency code for a country.
 * @param {string} countryCode - ISO 3166-1 alpha-2 code
 * @returns {string} ISO 4217 currency code
 */
export const getCurrencyForCountry = (countryCode) => {
  return COUNTRY_CURRENCY_MAP[countryCode] || 'USD';
};

/**
 * Get country info by code
 * @param {string} countryCode
 * @returns {object|undefined}
 */
export const getCountryInfo = (countryCode) => {
  return COUNTRIES.find(c => c.code === countryCode);
};

/**
 * Get display label for a country (flag + name)
 * @param {string} countryCode
 * @returns {string}
 */
export const getCountryLabel = (countryCode) => {
  const country = getCountryInfo(countryCode);
  return country ? `${country.flag} ${country.name}` : countryCode;
};

export default COUNTRIES;

